// extracted by mini-css-extract-plugin
module.exports = {"installAppButton":"InstallAppButton_installAppButton__EgUDC","bookmarkBadge":"InstallAppButton_bookmarkBadge__3M3Cn"};